export const AZURE_FACE_MATCH_STATUS_NOT_DONE = 'not_done';
